(function () {
  function initReviewSlider(root) {
    if (!root) return;
    var track = root.querySelector('[data-mc-pink-review-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.mc-pink-review'));
    var prev = root.querySelector('[data-mc-pink-prev]');
    var next = root.querySelector('[data-mc-pink-next]');
    var dotsWrap = root.querySelector('[data-mc-pink-dots]');
    var index = 0;

    function visible() {
      if (window.innerWidth <= 640) return 1;
      if (window.innerWidth <= 860) return 2;
      if (window.innerWidth <= 1100) return 3;
      return 4;
    }
    function maxIndex() { return Math.max(cards.length - visible(), 0); }
    function goTo(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      if (cards[index]) {
        track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      updateDots();
    }
    function updateDots() {
      if (!dotsWrap) return;
      Array.prototype.slice.call(dotsWrap.querySelectorAll('button')).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= maxIndex(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mc-pink-dot';
        b.setAttribute('aria-label', 'Go to review ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { goTo(n); }); })(i);
        dotsWrap.appendChild(b);
      }
      updateDots();
    }
    if (prev) prev.addEventListener('click', function () { goTo(index <= 0 ? maxIndex() : index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index >= maxIndex() ? 0 : index + 1); });
    track.addEventListener('scroll', function () {
      var closest = cards.reduce(function (best, card) {
        return Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(best.offsetLeft - track.scrollLeft) ? card : best;
      }, cards[0]);
      index = Math.min(cards.indexOf(closest), maxIndex());
      updateDots();
    }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); goTo(index); });
    buildDots();
  }

  function init() {
    document.querySelectorAll('[data-mc-pink-review-slider]').forEach(initReviewSlider);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (event) { initReviewSlider(event.target); });
})();
